import styled from 'styled-components';

import POISection from './POISection';

export default styled(POISection)`
  height: 100%;

  display: flex;

  .sidebar {
    min-width: 350px;
    flex: 0;
    background-color: #fff;
    display: flex;
    flex-direction: column;
  }

  .map-container {
    height: 100%;
    flex: 1;
  }
`;
